// extracted by mini-css-extract-plugin
module.exports = {"block":"vicdeR","content":"IPbhDp","description":"cMwHPi","title":"wPKb2T","toolsWrapper":"Vf4Zi3"};